const MODULE = 'ORDINARY_OPERATION_DETAILS'
export const ADD = `${MODULE}/ADD`
export const FETCH_DETAILS_REQUEST = `${MODULE}/FETCH_DETAILS_REQUEST`
export const FETCH_DETAILS_SUCCESS = `${MODULE}/FETCH_DETAILS_SUCCESS`
export const FETCH_DETAILS_FAILED = `${MODULE}/FETCH_DETAILS_FAILED`
export const FETCH_RELATED_ASSETS_REQUEST = `${MODULE}/FETCH_RELATED_ASSETS_REQUEST`
export const FETCH_RELATED_ASSETS_FAILED = `${MODULE}/FETCH_RELATED_ASSETS_FAILED`
export const FETCH_RELATED_ASSETS_SUCCESS = `${MODULE}/FETCH_RELATED_ASSETS_SUCCESS`
export const CLEAR_RELATED_ASSETS = `${MODULE}/CLEAR_RELATED_ASSETS`
